/* eslint-disable no-underscore-dangle */
import _, {
 isNaN, isNil, keys, size,
} from 'lodash'
import xlsx from 'xlsx'
import moment from 'moment'

export const isEveryIndex = (arr, value) => (
  arr.every(v => v === value)
)

export const passwordValidator = password => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(password)

export default isEveryIndex

export const checkInt = (input) => {
  const acceptedKeyCode = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 37, 38, 39, 40, 9]
  return _.includes(acceptedKeyCode, input.keyCode)
}

export const checkFloat = (input) => {
  const acceptedKeyCode = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 110, 190, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 37, 38, 39, 40, 9]
  return _.includes(acceptedKeyCode, input.keyCode)
}

export const checkNotNumber = (input) => {
  const acceptedKeyCode = [69, 107, 109, 187, 189]
  return _.includes(acceptedKeyCode, input.keyCode)
}

export const checkSpecial = input => /[!@#$%^&*)(]/g.test(input)

export const monthConverter = (input) => {
  switch (input) {
    case '01': return 'มกราคม'
    case '02': return 'กุมภาพันธ์'
    case '03': return 'มีนาคม'
    case '04': return 'เมษายน'
    case '05': return 'พฤษภาคม'
    case '06': return 'มิถุนายน'
    case '07': return 'กรกฎาคม'
    case '08': return 'สิงหาคม'
    case '09': return 'กันยายน'
    case '10': return 'ตุลาคม'
    case '11': return 'พฤศจิกายน'
    case '12': return 'ธันวาคม'
    default: return 'none'
  }
}

export const toSafeFloat = value => (_.isNaN(parseFloat(value)) ? 0 : parseFloat(value))

export const checkCustomerWithCustomRefId = input => input.groupId === 4 || _.includes([78], input.customerId || input.id)

export const renderText = value => (value || 'ไม่ระบุ')

const checkValue = requiredFields => (
  _.some(requiredFields, (itemInRequiredFields) => {
    // Item is array
    if (_.isArray(itemInRequiredFields)) {
      return _.size(itemInRequiredFields) === 0 || _.some(itemInRequiredFields, (valueInArrayItem) => {
        if (_.isObject(valueInArrayItem)) {
          return _.some(valueInArrayItem, valueInObject => _.isNaN(valueInObject) || _.isNil(valueInObject) || valueInObject === '' || (_.isArray(valueInObject) && _.size(valueInObject) === 0))
        } return _.isNaN(valueInArrayItem) || _.isNil(valueInArrayItem) || valueInArrayItem === '' || (_.isArray(valueInArrayItem) && _.size(valueInArrayItem) === 0)
      })
    }
    // Item is not array
    return _.isNaN(itemInRequiredFields) || _.isNil(itemInRequiredFields) || itemInRequiredFields === '' || (_.isArray(itemInRequiredFields) && _.size(itemInRequiredFields) === 0) || (_.isEmpty(itemInRequiredFields) && _.isObject(itemInRequiredFields)) || _.some(itemInRequiredFields, (valueInItem) => {
      if (_.isObject(valueInItem)) {
        return _.some(valueInItem, valueInObject => _.isNaN(valueInObject) || _.isNil(valueInObject) || valueInObject === '' || (_.isArray(valueInObject) && _.size(valueInObject) === 0))
      }
      return _.isNaN(valueInItem) || _.isNil(valueInItem) || valueInItem === '' || (_.isArray(valueInItem) && _.size(valueInItem) === 0)
    })
  })
)

export const verifyFields = (isCreate, requiredFields, allFields) => (
  isCreate
    ? _.isEmpty(requiredFields) || checkValue(requiredFields)
    : _.isEmpty(allFields) || checkValue(requiredFields)
)

export const checkURLIsImage = url => url.match(/\.(jpeg|jpg|gif|png)$/) != null

export const getVariantName = variant => _.join(_.dropRightWhile([variant.option1 && variant.option1.optionName, variant.option2 && variant.option2.optionName, variant.option3 && variant.option3.optionName], o => _.isNull(o)), ' / ')

export const readExcelFile = (file, setData) => {
  const reader = new FileReader()
  const rABS = !!reader.readAsBinaryString
  reader.onload = (e) => {
    const bstr = e.target.result
    const xlsxInstance = xlsx.read(bstr, { type: rABS ? 'binary' : 'array' })
    const data = xlsx.utils.sheet_to_json(xlsxInstance.Sheets.Sheet1)
    setData(data.map(obj => ({
      date: obj.date ? `${moment(new Date((obj.date - (25569)) * 86400 * 1000)).format('YYYY/MM/DD')}` : undefined,
      /*
        1000 to Milisecond
        86400 = Seconds in a day
        25569 = Days between 1970/01/01 and 1900/01/01 (min date in Windows Excel)
      */
      costType: obj.costType ? `${obj.costType}` : undefined,
      costName: obj.costName ? `${obj.costName}` : undefined,
      amount: isNaN(parseFloat(obj.amount)) ? 0 : obj.amount,
    })))
  }
  if (rABS) reader.readAsBinaryString(file)
  else reader.readAsArrayBuffer(file)
  return null
}

export const readImportFleetCardExcelFile = (gasstationCompany, file, setData) => {
  const reader = new FileReader()
  const rABS = !!reader.readAsBinaryString
  reader.onload = (e) => {
    const bstr = e.target.result
    const xlsxInstance = xlsx.read(bstr, { type: rABS ? 'binary' : 'array' })
    switch (gasstationCompany) {
      case 'BANGCHAK': {
        const data = xlsx.utils.sheet_to_json(xlsxInstance.Sheets.Sheet1)
        const trimData = JSON.parse(JSON.stringify(data).replace(/"\s+|\s+"/g, '"'))
        setData(trimData.map((obj, idx) => ({
          date: obj.TRN_DATE ? `${moment(new Date((obj.TRN_DATE - (25569)) * 86400 * 1000)).format('YYYY/MM/DD')}` : undefined,
          officialName: obj.MERCHANT_NAME_THAI,
          totalPrice: obj.AMT_BAHT,
          reference: `${obj.INVOICE_NO}`,
          quantity: obj.QTY_LITRE,
          row: idx + 2,
        })))
        break
      }
      case 'SHELL': {
        const data = xlsx.utils.sheet_to_json(xlsxInstance.Sheets.Sheet1)
        const trimData = JSON.parse(JSON.stringify(data).replace(/"\s+|\s+"/g, '"'))
        setData(trimData.map((obj, idx) => ({
          date: obj.วันที่ทำรายการ2 ? `${moment(new Date(`20${obj.วันที่ทำรายการ2.split('/').reverse().join('/')}`)).format('YYYY/MM/DD')}` : undefined,
          officialName: obj.ชื่อสถานี,
          totalPrice: obj.ยอดสุทธิ,
          reference: obj['#Transaction identifier'],
          quantity: parseFloat(obj.ปริมาณเชื้อเพลิง),
          row: idx + 2,
        })))
        break
      }
      case 'CALTEX': {
        const data = xlsx.utils.sheet_to_json(xlsxInstance.Sheets[xlsxInstance.SheetNames[0]])
        const trimData = JSON.parse(JSON.stringify(data).replace(/"\s+|\s+"/g, '"'))
        setData(trimData.slice(0, trimData.length - 2).map((obj, idx) => ({
          date: obj['Date/Time'] ? `${moment(new Date(obj['Date/Time'].split(' ')[0].split('/').reverse().join('/'))).format('YYYY/MM/DD')}` : undefined,
          officialName: obj.Location,
          totalPrice: parseFloat(obj['Cust Amount']),
          reference: obj['Reference #'],
          row: idx + 2,
        })))
        break
      }
      case 'ESSO':
      case 'PTT': {
        const data = xlsx.utils.sheet_to_json(xlsxInstance.Sheets[xlsxInstance.SheetNames[0]])
        const trimData = JSON.parse(JSON.stringify(data).replace(/"\s+|\s+"|"_+/g, '"'))
        const selectedRow = trimData.filter(row => size(row) > 16)
        setData(selectedRow.map((obj, idx) => ({
          date: obj.EMPTY_4 ? `${moment(new Date(obj.EMPTY_4.split('/').reverse().join('/'))).format('YYYY/MM/DD')}` : undefined,
          officialName: obj.EMPTY_1,
          totalPrice: obj.EMPTY_10,
          reference: obj.EMPTY_6,
          quantity: obj.EMPTY_8,
          row: 'ไม่สามารถระบุได้',
        })))
        break
      }
      default: {
        console.log()
      }
    }
  }
  if (rABS) reader.readAsBinaryString(file)
  else reader.readAsArrayBuffer(file)
  return null
}


// Format date range
export const formatDateRange = (startDate, endDate) => {
  const start = moment(startDate).format('DD/MM/YYYY')
  const end = endDate ? moment(endDate).format('DD/MM/YYYY') : 'ใช้ปัจจุบัน'
  if (!startDate && !endDate) return '-'
  if (!startDate) return end
  if (!endDate) return `${start} -`
  if (start === end) return `${start} - ${end}`
  return `${start || '-'} - ${end || '-'}`
}

export const isNilOrEmptyString = value => isNil(value) || value === ''
